import React from "react";
import { MenuItemProps, Tag } from "@chakra-ui/react";
import { MenuItem as MenuItemChakra } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { colors } from "../../../../../../theme/colors";

const MenuItem: React.FC<MenuItemProps> = observer(({ children, ...rest }) => (
	<MenuItemChakra 
    _focus={{ bg: "transparent" }} 
    _hover={{ bg: "transparent" }} 
    textColor={colors.black[500]} 
    lineHeight="24px" 
    fontSize="18px"
    display="flex" 
    gap={"10px"} 
    justifyContent="space-between"
    {...rest}
  >
		{children}
	</MenuItemChakra>
));

export default MenuItem;
